import React, { Component } from 'react';
import moment from "moment";
import {isEmpty} from '../../../../../../utils/helpers';
import Loader from '../../../../../../components/Loader';
import { withRouter } from "react-router-dom";
import TroubleTicketServiceLines from "src/containers/AccountDetails/Panels/LeftPanel/Tabs/TroubleTickets/TroubleTicketServiceLines";

export class TroubleTicketServices extends Component {

  state = {
    activeServiceDropdown: '',
    activeServiceLineDropdownId: '',
    search: '',
  }

  handleActiveDropDown = (type, id, forceClose) => {
    if (type === 'service') {
      this.setState({
        activeServiceDropdown: (forceClose || this.state.activeServiceDropdown === id) ? '' : id,
        activeServiceLineDropdownId: ''
      });
    }
    else {
      this.setState({
        activeServiceLineDropdownId: (forceClose || this.state.activeServiceLineDropdownId === id) ? '' : id,
        activeServiceDropdown: ''
      });
    }
  };

  handleProductAndPackagesClick = (planId, serviceLineId, planRelation, startDate) => {
    if (moment(startDate).isAfter(moment())) {
      alert(`Line has a future date, ${moment(startDate).format('MM/DD/YYYY')}. You are not allowed to make changes to the selected line at this time.`);
      return;
    }
    let data = {
      wizardType: 'updateService',
      wizardData: {
        planId,
        serviceLineId,
        planRelation
      }
    };
    this.props.showAccessModal(true);
    this.props.showAccountDetailsWizard(data);
    this.props.history.push(`/account-details/${this.props.accountInfo.id}?taskid=${this.props.taskInfo.id}`);
    // this.props.showModal('GENERIC_CLOSE_MODAL', {
    //   title: 'CONFIRM EXIT TASK DETAILS',
    //   text: 'Are you sure you want to exit this task?'
    // })
  };

  handleRemoveServiceLinesClick = (accountInfo, serviceInfo) => {
    let data = {
      wizardType: 'removeServiceLines',
      wizardData: {
        accountInfo,
        service: serviceInfo
      }
    };
    this.props.showAccessModal(true);
    this.props.showAccountDetailsWizard(data);
    this.props.history.push(`/account-details/${this.props.accountInfo.id}?taskid=${this.props.taskInfo.id}`);
  };

  showAddEquipmentWizardHandler = (data) => {
    this.props.showAccessModal(true);
    this.props.showAccountDetailsWizard(data);
    this.props.history.push(`/account-details/${this.props.accountInfo.id}?taskid=${this.props.taskInfo.id}`);
  }

  showRemoveEquipmentWizardHandler = (data) => {
    this.props.showAccessModal(true);
    this.props.showAccountDetailsWizard(data);
    this.props.history.push(`/account-details/${this.props.accountInfo.id}?taskid=${this.props.taskInfo.id}`);
  }

  showSwapEquipmentWizardHandler = (data) => {
    this.props.showAccessModal(true);
    this.props.showAccountDetailsWizard(data);
    this.props.history.push(`/account-details/${this.props.accountInfo.id}?taskid=${this.props.taskInfo.id}`);
  }

  showValidateServiceWizardHandler = (data) => {
    this.props.showAccessModal(true);
    this.props.showAccountDetailsWizard(data);
    this.props.history.push(`/account-details/${this.props.accountInfo.id}?taskid=${this.props.taskInfo.id}`);
  }

  render() {
    const {
      activeServiceDropdown,
      activeServiceLineDropdownId,
      search
    } = this.state;

    const {
      servicesLoading,
      servicesData,
      showHistoricalData,
      history,
      serviceLineId,
    } = this.props;

    if (servicesLoading) {
      return <Loader />;
    }

    if (!servicesLoading && isEmpty(servicesData)) {
      return <p className="tab-pane-message-empty">No data found</p>;
    }

    let filteredData = servicesData.filter(service =>
      service.serviceLines.some(serviceLine => serviceLine.serviceLineId === serviceLineId.serviceLineId)
    );
    return (
      <>
        {!servicesLoading && filteredData.map((service, index) => (
      <TroubleTicketServiceLines
        key={index}
        searchWord={search}
        serviceInfo={service}
        activeServiceDropdown={activeServiceDropdown}
        activeServiceLineDropdownId={activeServiceLineDropdownId}
        handleActiveDropDown={this.handleActiveDropDown}
        handleProductAndPackagesClick={this.handleProductAndPackagesClick}
        handleRemoveServiceLinesClick={this.handleRemoveServiceLinesClick}
        showAddEquipmentWizardHandler={this.showAddEquipmentWizardHandler}
        showRemoveEquipmentWizardHandler={this.showRemoveEquipmentWizardHandler}
        showSwapEquipmentWizardHandler={this.showSwapEquipmentWizardHandler}
        showValidateServiceWizardHandler={this.showValidateServiceWizardHandler}
        showHistoricalData={showHistoricalData}
        history={history}
  />
))}

      </>
    );
  }
}

export default withRouter(TroubleTicketServices);
